<template>
    <div v-if="scannedRequest">
        <span class="coupon-label">
            {{ $t('coupon.scannedRequest') }}
        </span>
        <span>{{ $t('base.yes') }}</span>
    </div>
</template>

<script>

export default {
    name: 'coupon-scanned-request',
    props: {
        appointment: { type: Object, required: true },
    },
    computed: {
        /**
         * Returns true if there a scanned request attach to the appointment
         */
        scannedRequest() {
            return this.appointment.clientData && this.appointment.clientData.scannedRequest;
        },
    },
};
</script>

<style lang="scss" scoped>

</style>
